<script setup>
import {inflect} from '@/helpers/string.js'
import {toRefs, computed} from 'vue'

//Props
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  count: {
    type: Number,
    default: 1,
  },
  includeCount: {
    type: Boolean,
    default: false,
  },
})

//Inflected
const {text, count, includeCount} = toRefs(props)
const inflected = computed(() => inflect(text.value, count.value, includeCount.value))
</script>

<template>
  {{ inflected }}
</template>
